module.exports = ".modal-dialog {\n  width: 90%;\n  max-height: 95%;\n  max-width: none;\n  overflow-y: auto; }\n\n.col-sm-2,\n.col-sm-1,\n.col-sm-3 {\n  padding-left: 4px;\n  padding-right: 4px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/economic-group/component/economic-group-create/economic-group-create.component.scss
// module id = ./src/app/economic-group/component/economic-group-create/economic-group-create.component.scss
// module chunks = main